import {
	GrantClientLicensesRequest,
	GrantClientLicensesResponse,
	Res
} from '../api';

import * as Events from './Events';
import * as Bus from './Bus';
import * as ModuleNames from './ModuleNames';

const TIME_BETWEEN_CHECKS = 6 * 60 * 1000; // 6 minutos igual que en el TPV nativo

const process = Bus.buildProcessFn('/bus/');

const handleResponse = async (response: GrantClientLicensesResponse) => {

	const invalidModules = response.Licenses.filter(x => !x.Granted).map(x => ModuleNames.getDescription(x.ModuleName));

	if (invalidModules.length > 0) {
		const message = Res.Msg.MSG_INVALID_MODULE_LICENSES(invalidModules.join('\r\n'));
		await Events.raise('license:invalid', message);
	}
};

export async function startChecking(machineId: string): Promise<void> {
	await check(machineId);
}

let intervalId: Nullable<NodeJS.Timeout> = null;

function startInterval(machineId: string) {
	intervalId = setInterval(async () => {
		await check(machineId);
	}, TIME_BETWEEN_CHECKS);
}

function stopInterval() {
	if (intervalId)
		clearInterval(intervalId);
}

async function check(machineId: string) {
	stopInterval();
	const request = new GrantClientLicensesRequest({ machineId: machineId });
	await process(request, handleResponse);
	startInterval(machineId);
}
